import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import useRazorpay from 'react-razorpay';
import PartnerPayment from './partnerpay.service';
import CryptoJS from 'crypto-js';
import { useHistory } from 'react-router-dom';
function useQuery() {
  return new URLSearchParams(useLocation().search);
}
declare global {
  interface Window {
    Razorpay: any;
  }
}
const CheckoutPage = () => {
  const query = useQuery();
  const orderId = query.get('orderId');
  const paymentMethod = query.get('paymentMethod') || 'UPI';
  const Razorpay = useRazorpay();
  const [loading, setLoading] = useState(true);
  const [razorpay, setRazorpay] = useState<any>({
    amount: null,
    paymentMethod: 'NEBK',
  });
  const history = useHistory();
  const loadRazorpayScript = (): Promise<void> => {
    return new Promise((resolve, reject) => {
      if (window.Razorpay) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => {
        if (window.Razorpay) resolve();
        else
          reject(new Error('Razorpay SDK loaded but Razorpay is undefined.'));
      };
      script.onerror = () => reject(new Error('Failed to load Razorpay SDK'));
      document.body.appendChild(script);
    });
  };

  const setInitialStateRazorpay = () => {
    setRazorpay({
      amount: null,
      transactionTypeId: '',
      paymentMethod: 'NEBK',
    });
  };

  const handlePaymentComplete = () => {
    history.push('/typage');
  };

  const setPaymentGatewayConfiguration = async (amt, ebOrderRef) => {
    await loadRazorpayScript();
    const options: any = {
      key: process.env.REACT_APP_RAZORPAY_KEY,
      amount: '',
      currency: 'INR',
      name: 'eBullion',
      description: 'Buy Metals',
      image:
        'https://ebullion-dev.s3.ap-south-1.amazonaws.com/assets/eb-logo.png',
      order_id: '',

      async handler(response: any) {
        const payload = {
          customerId: razorpay.customerId,
          razorpayOrderId: response.razorpay_order_id,
          razorpayPaymentId: response.razorpay_payment_id,
          razorpaySignature: response.razorpay_signature,
          razorpayRequestBody: {
            amount: razorpay.amount,
            currency: 'INR',
          },
        };

        // setInitialStateRazorpay();
        await checkPaymentStatus(response.razorpay_payment_id, ebOrderRef);
        handlePaymentComplete();
      },

      prefill: {
        method: paymentMethod === 'UPI' ? 'upi' : 'netbanking',
      },
      modal: {
        ondismiss: () => {
          console.log('Payment popup closed.');
          window.location.reload(); // Refresh the page
        },
      } as any,
      config: {
        display: {
          language: 'en',
          blocks: {
            banks: {
              name:
                paymentMethod === 'UPI' ? 'Pay via UPI' : 'Pay via Net Banking',
              instruments: [
                {
                  method:
                    paymentMethod === 'UPI' || paymentMethod === 'WALLET_UPI'
                      ? 'upi'
                      : 'netbanking',
                },
              ],
            },
          },
          sequence: ['block.banks'],
          preferences: {
            show_default_blocks: false,
          },
        },
      },

      theme: {
        hide_topbar: false,
        color: '#141034',
        backdrop_color: 'rgba(0, 0, 0, 0.90)',
      },
      timeout: 180,
    };

    if (paymentMethod === 'UPI' || paymentMethod === 'NEBK') {
      options.amount = amt.toString();
      options.order_id = orderId;
      const razorPay = new Razorpay(options);
      return razorPay.open();
    }
  };

  const checkPaymentStatus = async (paymentId, orderId) => {
    try {
      let payload = {
        paymentId,
        orderId,
      };
      setLoading(true);
      const res = await PartnerPayment.paymentUpdate(payload);
    } catch (error) {
      console.log(error);
    }
  };
  //   payment/order/details
  const getAmountFunction = async () => {
    try {
      const data = { orderId: orderId };

      const encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(data),
        process.env.REACT_APP_VI_PARTNER_KEY
      ).toString();
      const encoded = encodeURIComponent(encrypted);
      //   const data = { bank_details: encrypted };

      const res = await PartnerPayment.getAmountDetails(encoded);
      if (res?.data?.data) {
        try {
          const decrypted = CryptoJS.AES.decrypt(
            decodeURIComponent(res?.data?.data),
            process.env.REACT_APP_VI_PARTNER_KEY!
          );

          const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);

          const parsed = JSON.parse(decryptedText);
          setPaymentGatewayConfiguration(parsed?.amount, parsed?.ebOrderRef);
        } catch (error) {
          console.error('Decryption or Parsing Failed:', error);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    if (orderId) {
      getAmountFunction();
      setLoading(false);
    }
  }, [orderId]);

  const styles = {
    container: {
      height: '100vh',
      backgroundColor: '#02042B', // Razorpay dark blue
      color: '#fff',
      display: 'flex',
      flexDirection: 'column' as const,
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'sans-serif',
    },
    spinner: {
      border: '6px solid #E5E5E5',
      borderTop: '6px solid #2B84EA', // Razorpay blue
      borderRadius: '50%',
      width: '60px',
      height: '60px',
      animation: 'spin 1s linear infinite',
    },
    text: {
      marginTop: '20px',
      fontSize: '1.5rem',
      color: '#FFFFFF',
    },
    subText: {
      marginTop: '8px',
      fontSize: '1rem',
      color: '#A0AEC0',
    },
  };

  return (
    <>
      <div style={styles.container}>
        <div style={styles.spinner}></div>
        <h2 style={styles.text}>Loading payment gateway...</h2>
        <p style={styles.subText}>Please do not refresh or close the tab</p>

        <style>
          {`@keyframes spin {
     0% { transform: rotate(0deg); }
     100% { transform: rotate(360deg); }
   }`}
        </style>
      </div>
    </>
  );
};

export default CheckoutPage;
